module.exports = __webpack_public_path__ + "js/0.6b4a3688.worker.js"